import { createAction } from 'redux-starter-kit';
import moment from 'moment';
import { requestFailed, requestStart, requestSucceded } from '../../domain/requests/RequestActions';
import { get, post, remove } from '../../../utility/via-fetch';
import { putNotification, putNotifications, removeNotification } from '../../domain/notification/NotificationActions';
import { addMessage } from '../application/messageUiActions';


// ACTIONS
export const editNotification = createAction('EDIT_NOTIFICATION');
export const cancelEditNotification = createAction('CANCEL_EDIT_NOTIFICATION');
export const fetchNotificationPageData = createAction('FETCH_NOTIFICATIONS_PAGE_DATA');

/**
 * An action for loading all the data for the main page.
 */
export function requestNotificationPageData() {
  return async (dispatch) => {
    const requestId = dispatch(requestStart(fetchNotificationPageData.toString()));
    dispatch(fetchNotificationPageData(requestId));

    try {
      const notifications = await get('/api/notifications/');

      // Store
      dispatch(putNotifications(notifications));
      dispatch(requestSucceded(requestId));
    } catch (error) {
      dispatch(requestFailed(requestId, error));
    }
  };
}

// CREATE
export const fetchAddNotification = createAction('FETCH_CREATE_NOTIFICATION');

export function requestAddNotification(notification, label) {
  return async (dispatch) => {
    const requestId = dispatch(requestStart(fetchAddNotification.toString()));
    dispatch(fetchAddNotification(requestId));
    try {
      // Save
      // eslint-disable-next-line no-param-reassign
      notification.active = true;
      notification.notificationId = await post('/api/notifications', {}, notification); // eslint-disable-line no-param-reassign

      // Domain - adjust to number as moment not serialised
      if (notification.startDateTime instanceof moment) {
        // eslint-disable-next-line no-param-reassign
        notification.startDateTime = notification.startDateTime.valueOf();
      }
      if (notification.endDateTime instanceof moment) {
        // eslint-disable-next-line no-param-reassign
        notification.endDateTime = notification.endDateTime.valueOf();
      }
      dispatch(putNotification(notification));

      // Request
      dispatch(cancelEditNotification());
      dispatch(requestSucceded(requestId, notification.notificationId));
      dispatch(addMessage('success', 'itemSaved', { item: label }));
    } catch (error) {
      dispatch(requestFailed(requestId, error));
    }
  };
}

// UPDATE
export const fetchUpdateNotification = createAction('FETCH_UPDATE_NOTIFICATION');

export function requestUpdateNotification(notification, label) {
  return async (dispatch) => {
    const requestId = dispatch(requestStart());
    dispatch(fetchUpdateNotification(requestId));
    try {
      // Save
      await post(`/api/notifications/${notification.notificationId}`, {}, notification);

      // Domain - adjust to number as moment not serialised
      if (notification.startDateTime instanceof moment) {
        // eslint-disable-next-line no-param-reassign
        notification.startDateTime = notification.startDateTime.valueOf();
      }
      if (notification.endDateTime instanceof moment) {
        // eslint-disable-next-line no-param-reassign
        notification.endDateTime = notification.endDateTime.valueOf();
      }
      dispatch(putNotification(notification));

      // Request
      dispatch(cancelEditNotification());
      dispatch(requestSucceded(requestId, notification.notificationId));
      dispatch(addMessage('success', 'itemUpdated', { item: label }));
    } catch (error) {
      dispatch(requestFailed(requestId, error));
    }
  };
}

// DELETE
export const fetchDeleteNotification = createAction('FETCH_DELETE_NOTIFICATION');

export function requestDeleteNotification(notification, label, fullDelete) {
  return async (dispatch) => {
    const requestId = dispatch(requestStart());
    dispatch(fetchDeleteNotification(requestId));
    try {
      if (fullDelete) {
        // Delete
        await remove(`/api/notifications/${notification.notificationId}`, {});
        dispatch(removeNotification(notification.notificationId));
      } else {
        // Save (active was made false)
        await post(`/api/notifications/${notification.notificationId}`, {}, notification);
        dispatch(putNotification(notification)); // active filtered out
      }

      // Request
      dispatch(requestSucceded(requestId, notification.notificationId));
      dispatch(addMessage('success', 'itemRemoved', { item: label }));
    } catch (error) {
      dispatch(requestFailed(requestId, error));
    }
  };
}
